export default "__VITE_ASSET__CMZRarq7__"